import { ICrystalDTO } from 'business/models/Models';
import { handleAttachmentDownload } from '../utils';
import React from 'react';

interface ICrystalContent {
  crystal: ICrystalDTO;
}
export const CryoprotectantContent = (props: ICrystalContent) => {
  const { crystal } = props;
  return (
    <div
      id="searchandfilter-infocomponents-cryoprotectant-content-wrapper"
      className="flex flex-col"
    >
      {crystal?.cryoprotectants?.map((cryoprotectant) => (
        <label
          id={`searchandfilter-infocomponents-cryoprotectant-label-${cryoprotectant.id}`}
          key={`cryoInfo-${cryoprotectant.id}`}
        >{`${cryoprotectant?.ingredient}_${cryoprotectant?.conc}_${cryoprotectant?.concUnit}_${cryoprotectant?.ph}_${cryoprotectant?.protocol}`}</label>
      ))}
    </div>
  );
};

export const SoakingContent = (props: ICrystalContent) => {
  const { crystal } = props;
  return (
    <div
      id="searchandfilter-infocomponents-soakingcontent-wrapper"
      className="flex flex-col"
    >
      {crystal.soakings?.map((soaking, index) => (
        <label
          id={`searchandfilter-infocomponents-soakingcontent-label-${index}`}
          key={`soak_${index}`}
        >{`${soaking.ingredient}_${soaking.conc}_${soaking.concUnit}_${soaking.time}_${soaking.timeUnit}_${soaking.textInfo}`}</label>
      ))}
    </div>
  );
};

export const NotesContent = (props: ICrystalContent) => {
  const { crystal } = props;
  return (
    <div id="searchandfilter-infocomponents-notescontent" className="border">
      <label id="searchandfilter-infocomponents-notescontent-label">
        {crystal.notes}
      </label>
    </div>
  );
};

export const AttachmentContent = (props: ICrystalContent) => {
  const { crystal } = props;
  return (
    <>
      {crystal.attachedFiles?.map((file, index) => (
        <button
          id={`searchandfilter-infocomponents-attachmentcontent-button-${index}`}
          key={`fil_${index}`}
          onClick={() => handleAttachmentDownload(file.id)}
          className="text-md m-0 mr-2 p-0 inline rounded-sm border-0 hover:underline bg-transparent max-w-md truncate"
        >
          {file.fileName}
        </button>
      ))}
    </>
  );
};
